import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';

interface categoriaContada {
  categoria: string,
  cant: number,
}

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private shared: RoutingVariablesService, private router: Router, private afs: AngularFirestore) { }

  categorias: string[] = []
  cursos = []
  categoriasContadas: categoriaContada[] = []

  ngOnInit(): void {
    this.cargarCategorias()
  }

  async cargarCategorias() {
    this.afs.collection("cursos").valueChanges().subscribe(async (cursos) => {
      this.cursos = cursos;
      this.categoriasContadas = []
      const doc = await this.afs.collection("global").doc("global").ref.get();
      this.categorias = doc.data()["categoria"];
      this.categorias.forEach(categoria => {
        const catCont: categoriaContada = {
          categoria: categoria,
          cant: 0
        }
        this.cursos.forEach(curso => {
          if (curso.publicado == true){
            if (curso.categoria == catCont.categoria) {
              catCont.cant += 1;
            }
          }
        })
        this.categoriasContadas = this.categoriasContadas.concat(catCont)
      })
      this.categoriasContadas.sort((a, b) => +b.cant - +a.cant)
    });
  }

  buscarCategoria(categoria) {
    const obj = { categoria: categoria };
    this.shared.pushData(obj);
    this.router.navigate(['/buscar']);
  }



}
